__turbopack_context__.v({
  "toggle": "Toggle-module-scss-module__5oqRIW__toggle",
  "toggle-circle": "Toggle-module-scss-module__5oqRIW__toggle-circle",
  "toggle-rect": "Toggle-module-scss-module__5oqRIW__toggle-rect",
  "wrapper": "Toggle-module-scss-module__5oqRIW__wrapper",
});
